import { createSlice } from '@reduxjs/toolkit';
import { exposureApi, ProfitLossResponse } from '../api/booksetApi';

type FancyProfitLoss = ProfitLossResponse | null;

const initialState: FancyProfitLoss = null;

export const fancyProfitLossSlice = createSlice({
  name: 'fancyProfitLoss',
  initialState: initialState as FancyProfitLoss,
  reducers: {
    clearFancyProfitLoss: (state) => null,
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      exposureApi.endpoints.getFancyProfitLoss.matchFulfilled,
      (_, { payload }) => payload
    );
  },
});

export const { clearFancyProfitLoss } = fancyProfitLossSlice.actions;

export default fancyProfitLossSlice.reducer;
